export default function NotFound() {
    return <div>Not Found 🥲</div>;
}